module.exports = "<div class=\"pageContent paddingLight classicArea withNav\">\n  <navbar></navbar>\n  <app-message success=\"$ctrl.success\" error=\"$ctrl.error\" info=\"$ctrl.fakeVar\" class=\"error\"></app-message>\n  <div class=\"limitContent updatePage\">\n    <p class=\"topBack\">\n      <a class=\"button back\" ng-click=\"$ctrl.$window.history.back()\" href=\"#\">{{ 'common.return' | translate }}</a>\n    </p>\n    <installation-guide></installation-guide>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/installation/installation.html
// module id = 790
// module chunks = 0